/* eslint-disable @typescript-eslint/no-var-requires */
import { FileSystemService } from '@/Electron/services/FileSystemService/FileSystemService';
import { IDocumentScanService } from './IDocumentScanService';

const path = require('path');

class ElectronDocumentScanService implements IDocumentScanService {
  private readonly _fileSystem: FileSystemService;

  constructor() {
    this._fileSystem = new FileSystemService();
  }

  loadDocuments(folderPath: string) {
    return this._fileSystem.loadFiles(folderPath);
  }

  moveLoadedDocuments(fromPath: string) {
    const toPath = path.resolve(fromPath, 'loaded');
    return this._fileSystem.moveFiles(fromPath, toPath);
  }

  clearFolder(folderPath: string) {
    return this._fileSystem.deleteFiles(folderPath);
  }

  checkIsPathExists(dirPath: string) {
    return this._fileSystem.isPathExists(dirPath);
  }
}

export const documentScanService = new ElectronDocumentScanService();
